<div id="print-generate-barcode">
  <!--  <div class="d-flex flex-wrap">-->
  <div class="card-grid-container">
    <div *ngFor="let item of data | async" class="card-qr-code {{ browser }}">
      <div class="card-r1 d-flex">
        <img alt="" class="img-bg d-none" src="./assets/media/illustrations/Label_QR-R1.png" />
        <div class="card-left"></div>
        <div class="card-center d-none">
          <p>{{ item.product_name }}</p>
        </div>
        <div class="card-right">
          <!--          <qr-code-->
          <!--            [backgroundAlpha]="0"-->
          <!--            [level]="'H'"-->
          <!--            [size]="50"-->
          <!--            [value]="item.qr_code_r1"-->
          <!--            class="custom-qr-code"-->
          <!--          ></qr-code>-->
          <p>{{ item.qr_code_r1 }}</p>
        </div>
      </div>
      <div class="card-r2 d-flex">
        <img alt="" class="img-bg d-none" src="./assets/media/illustrations/Label_QR-R2.png" />
        <div class="card-left"></div>
        <div class="card-center d-none">
          <p>{{ item.product_name }}</p>
        </div>
        <div class="card-right">
          <!--          <qr-code-->
          <!--            [backgroundAlpha]="0"-->
          <!--            [level]="'H'"-->
          <!--            [size]="50"-->
          <!--            [value]="item.qr_code_r2"-->
          <!--            class="custom-qr-code"-->
          <!--          ></qr-code>-->
          <p>{{ item.qr_code_r2 }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
